import React from 'react';
import { ChevronDown } from 'lucide-react';
import { faqs } from '../../data/foundingProgram';
export function FaqSection() {
  return <section className="border-b border-[#D4AF37]/12 bg-[#08070A]" data-id="element-1353" data-mp="21hmrj0cflz8w">
      <div className="mx-auto grid w-full max-w-6xl gap-10 px-5 py-20 sm:px-8 lg:grid-cols-[0.55fr_1.45fr] lg:gap-16" data-id="element-1354" data-mp="2gfp05oyblax0">
        <div data-id="element-1355" data-mp="2bhnfx0p5r5jy">
          <p className="text-[10px] font-medium uppercase tracking-[0.32em] text-[#D4AF37]" data-id="element-1356" data-mp="2bh3wtgnrub4c">
            Questions
          </p>
          <h2 className="mt-5 font-serif text-3xl text-[#FDFBF7] sm:text-5xl" data-id="element-1357" data-mp="1iroo4xjkwubl">
            Before we speak.
          </h2>
        </div>

        <div className="border-t border-[#D4AF37]/15" data-id="element-1358" data-mp="1xhmg7okmq462">
          {faqs.map(faq => <details key={faq.question} className="group border-b border-[#D4AF37]/15" data-id="element-1359" data-mp="1spkvrfdb574y">
              <summary className="flex cursor-pointer list-none items-center justify-between gap-6 py-5 text-left text-[#FDFBF7] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#D4AF37]" data-id="element-1360" data-mp="14yp7utbz2w2z">
                <span className="font-light" data-id="element-1361" data-mp="2vkf0ujjkc5ce">{faq.question}</span>
                <ChevronDown className="h-4 w-4 shrink-0 text-[#D4AF37] transition-transform duration-200 ease-out group-open:rotate-180" aria-hidden="true" data-id="element-1362" data-mp="2zlqjg540rqb3" />
              </summary>
              <p className="max-w-2xl pb-6 pr-10 text-sm font-light leading-relaxed text-[#FDFBF7]/60" data-id="element-1363" data-mp="39bto52ki6sp9">
                {faq.answer}
              </p>
            </details>)}
        </div>
      </div>
    </section>;
}